/**
 * A copied container's SMSWiser campaign → one of the target group's
 * campaigns (every container runs on its own campaign of the group); v2:
 * its twin by name, the group's only one, or its first — to confirm.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { GroupCopyCampaignRow } from '@trafficpulse/shared';

import { SearchableSelect } from '@/components/ui';
import { middleTruncate } from '@/features/drop-generator/components/campaign/campaign-scope';

import { matchBadge } from '../MatchBadge';
import { PickRow, usedByLine } from '../PickRow';

interface Props {
  row: GroupCopyCampaignRow;
  options: Array<{ wiserId: number; name: string }>;
  answered: boolean;
  onPick: (target: number) => void;
  /** In a fold: one line (27/10/2026). */
  compact?: boolean;
}

export const CampaignPick: FC<Props> = ({ row, options, answered, onPick, compact }) => (
  <PickRow
    compact={compact}
    name={row.sourceName}
    source={<span className="truncate" title={row.sourceName}>{middleTruncate(row.sourceName, 40)}</span>}
    select={
      <SearchableSelect
        options={options.map((o) => ({ value: String(o.wiserId), label: o.name, optionContent: <span className="block truncate" title={o.name}>{o.name}</span> }))}
        value={row.target === null ? '' : String(row.target)}
        onChange={(v) => onPick(Number(v))}
        placeholder={options.length === 0 ? 'The target group has no campaign' : 'Pick a campaign…'}
        searchPlaceholder="Search a campaign…"
        disabled={options.length === 0}
        className="h-8"
      />
    }
    badge={matchBadge(row.how, row.target !== null, answered)}
    meta={usedByLine(row.usedBy)}
    onConfirm={row.target !== null ? () => onPick(row.target!) : undefined}
  />
);
